import { ComponentProps, FC } from 'react';
import ConfirmModal from '../confirm';

type Props = Omit<ComponentProps<typeof ConfirmModal>, 'variant'>;

export const DeleteModal: FC<Props> = (props) => <ConfirmModal {...props} variant="delete" />;

export default DeleteModal;
